import React from "react";
import { useParams } from "react-router-dom";
import CompanyMemberForm from "../../components/company/CompanyMemberForm";
import PremiumFormPanel from "../../components/PremiumFormPanel";
import usePremiumResource from "../../hooks/usePremiumResource";
import { premiumPaths } from "../../navigation";

/** Odczytuje dostęp wskazanej osoby i blokuje edycję konta nieaktywnego lub usuniętego. */
export default function EditCompanyMemberPage({ company, token }) {
  const { memberId } = useParams();
  const url = `/organizations/${company.id}/members`;
  const resource = usePremiumResource(token, url);
  const members = resource.data?.members || [];
  const member = members.find((item) => item.userId === memberId);
  const error =
    resource.data && (!member || member.active === false)
      ? "Nie znaleziono aktywnego użytkownika z dostępem do tej firmy."
      : "";
  const listPath = premiumPaths.members(company.id);
  return (
    <PremiumFormPanel
      title="Edytuj dostęp użytkownika"
      resource={resource}
      error={error}
      backTo={listPath}
    >
      <CompanyMemberForm
        key={memberId}
        member={member}
        members={members}
        token={token}
        url={url}
        listPath={listPath}
      />
    </PremiumFormPanel>
  );
}
